import type { StateSchema } from '@/app/providers/storeProvider';

export const getInvestorFeatureAvailability = (state: StateSchema): boolean =>
    state.auth?.userInfo.role === 'investor' || state.auth?.userInfo.role === 'admin';
